import { USER_ENTITLEMENTS_API } from 'constants/AppConstants';
import { getTokenFromUrl } from 'utils/auth.utils';
import {
  AUTHORIZE_ROUTE,
} from 'constants/RouteConstants';
import { isOpenSitemapPath } from 'utils/sitemapOpenPage.utils';

const isOpenSitemapPage = () => {
  if (typeof globalThis.window === 'undefined') return false;
  // window.location includes the /myev basename; history paths do not.
  return isOpenSitemapPath(globalThis.window.location?.pathname);
};

/**
 * Service to fetch user entitlements object
 */
const getUserEntitlements = async () => {
  try {
    const token = getTokenFromUrl();
    const response = await fetch(`${USER_ENTITLEMENTS_API}?appCode=myev`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });

    const json = await response.json();
    // Never bounce open email pages to Viewpoint login on a stale/expired token
    if (response.status === 401 && !isOpenSitemapPage()) {
      globalThis.window.location.href = AUTHORIZE_ROUTE;
      return { ok: false, json };
    }

    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, error };
  }
};

export default getUserEntitlements;
